import { useQuery } from '@tanstack/react-query';

import { UserKey } from './keys';
import { UserService } from './userService';

export function useGetManagedUsers() {
  return useQuery({
    queryKey: [UserKey.USERS],
    queryFn: () => UserService.getManagedUsers().then((response) => response.data),
  });
}
